import React from 'react';
import { Box, Typography } from '@mui/material';
import { AcUnit } from '@mui/icons-material';
import { GREEN, INK, LINE, MINT } from './marketing/MarketingKit';

/**
 * Top-of-page announcement banner. Shown to customers and providers.
 * Toggle visibility by rendering conditionally or removing from App.tsx.
 */
const AnnouncementBanner: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100vw',
        boxSizing: 'border-box',
        py: 0.9,
        px: 2,
        bgcolor: MINT,
        color: INK,
        borderBottom: `1px solid ${LINE}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        overflow: 'hidden',
      }}
    >
      <AcUnit sx={{ fontSize: 16, color: GREEN, flexShrink: 0 }} />
      <Typography sx={{ fontSize: '0.85rem', fontWeight: 500, lineHeight: 1.4, overflowWrap: 'break-word' }}>
        Need snow removal? It's not too early to submit your request!
      </Typography>
    </Box>
  );
};

export default AnnouncementBanner;
